import { postWithJson, postWithFormData } from 'library/utils/serviceUtil'
import axios from 'axios'

// 获取拥护user-table信息
export const getInfo = params => postWithJson('/staff/getStaff.json', params);

// 获取部门年度调整次数
export const queryListCount = params => postWithJson('/budgetYearAdjustApply/queryListCount.json', params);

// 新增年度预算
// export const addYearAdjust = params => postWithJson('/budgetYearAdjustApply/add.json', params);
export const addYearAdjust = params => postWithJson('/budgetYearAdjustApply/start.json', params);

// 年度预算调整列表
export const getYearAdjustList = params => postWithJson('/budgetYearAdjustApply/list.json', params);

// 年度预算调整详情
export const getYearAdjustDetail = params => postWithJson('/budgetYearAdjustApply/detail.json', params);

// 删除年度预算调整
export const delBudgetYear = params => postWithJson('/budgetYearAdjustApply/del.json', params);

// 导入模板
export const importBudgetExcel = params => postWithFormData('/budgetYearAdjustApplyDetail/importExcel.json', params);

// 审批模板
export const operareProcess = params => postWithJson('/budgetYearAdjustApply/operateProcess.json', params);

// 查询流程状态
export const queryApplyStatusList = params => get('/application/ApplyStatus.json', params);

//  查询的数据类型 1全部组织架构[主体-归属-责任中心-一级部门-事业部][不做数据权限控制] 2科目[不做数据权限控制] 3半年度【预算周期】 4年度【预算周期】5组织架构[主体-归属-责任中心-一级部门][做数据权限控制] 6一级部门[做数据权限控制] 7科目[做数据权限控制]
export const getOriTree = params => postWithJson('/budgetDetailTemp/dic/treeList.json', params);

// 调整申请查询预算金额、调整后金额，冻结金额、执行后金额
export const queryAlterMoney = params => postWithJson('/budgetYearAdjustApplyDetail/queryModey.json', params);

// 查询EHR一级部门
export const getEhrFirstDepts = params => postWithJson('/budgetDetailTemp/getEhrFirstDepts.json', params);

// 获取调整的一级部门
export const getAdjustFirstDeptList = params => postWithJson('/common/adjustFirstDeptList.json', params);

/**
 * 事业部列表
 *
 * @return {Promise}
 */
export const getBusinessUnitList = (params) => postWithJson(`/common/getBusinessUnit.json`, params)

// 获取预算周期
export const queryYearList = (params) => postWithJson(`/budgetYearAdjustApply/queryYearList.json`, params)


// 下载模板
export const downloadTemplate = (params) => axios.get(`/common/download.json?id=${params.id}`, { responseType: 'arraybuffer' })

// 上传弹性调整附件
export const importGrantExcel = (params) => postWithFormData('/budgetYearAdjustApplyDetail/importGrantExcel.json', params)

// 弹性授予获取已授予金额和待授予金额
export const queryGrateModey = (params) => postWithJson(`/budgetYearAdjustApplyDetail/queryGrateModey.json`, params)
